import React from "react";
import { useTranslation } from "react-i18next";

function AutonomousResponse({ result, cardStyle }) {
const { t } = useTranslation();

return (

<div style={cardStyle}>

<h3>{t("commandCenter.autonomousResponse.title")}</h3>

<div
style={{
display:"flex",
flexDirection:"column",
gap:"15px"
}}
>

<div>

<b>{t("commandCenter.autonomousResponse.modeLabel")}</b>{" "}

{
result?.prediction?.risk==="SAFE"
? t("commandCenter.status.monitoring")

: result?.prediction?.risk==="WARNING"
? t("commandCenter.status.escalation")

: t("commandCenter.status.intervention")
}

</div>

<div>

<b>{t("commandCenter.autonomousResponse.statusLabel")}</b>{" "}

{
result?.prediction?.risk==="SAFE"
? t("commandCenter.status.activeObservation")

: result?.prediction?.risk==="WARNING"
? t("commandCenter.status.adminAlertActive")

: t("commandCenter.status.emergencyResponse")
}

</div>

<div>

<b>{t("commandCenter.autonomousResponse.actionLabel")}</b>{" "}

{result?.decision?.actions?.[0] ? t(`commandCenter.actionsList.${result.decision.actions[0]}`) : t("commandCenter.autonomousResponse.defaultAction")}

</div>

<div>

<b>{t("commandCenter.autonomousResponse.confidenceLabel")}</b>{" "}

{result?.prediction?.confidence}%

</div>

<div
style={{
marginTop:"10px",
padding:"12px",
borderRadius:"10px",
background:
result?.prediction?.risk==="SAFE"
? "#dcfce7"

: result?.prediction?.risk==="WARNING"
? "#fef3c7"

: "#fee2e2",
fontWeight:"bold",
color:"#111827"
}}
>

{
result?.prediction?.risk==="SAFE"
? t("commandCenter.autonomousResponse.safeMessage")

: result?.prediction?.risk==="WARNING"
? t("commandCenter.autonomousResponse.warningMessage")

: t("commandCenter.autonomousResponse.criticalMessage")
}

</div>

</div>

</div>

);

}

export default AutonomousResponse;